import React from "react";

export default function MSAccess_DatePart() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_DatePart</h1>
      <p>This is the MSAccess_DatePart component generated from the SQL JSON.</p>
    </div>
  );
}
